module.exports = __webpack_public_path__ + "static/InterFaceXBold-7775550044b925e9e267bb83792bcfb0.woff2";